import { RouteObject } from "react-router-dom";
import PaymentTermsList from "./pages/PaymentTermsList";

const paymentTermsRoutes: RouteObject[] = [
  {
    path: "/payment-terms",
    element: <PaymentTermsList />,
  },
];

export default paymentTermsRoutes;